<script setup>

</script>

<template>
  <svg viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.33366 0.333374C1.86033 0.333374 0.666992 1.52671 0.666992 3.00004V19C0.666992 20.4734 1.86033 21.6667 3.33366 21.6667H24.667C26.1403 21.6667 27.3337 20.4734 27.3337 19V3.00004C27.3337 1.52671 26.1403 0.333374 24.667 0.333374H3.33366ZM3.33366 3.00004H24.667V4.33598L14.0003 11L3.33366 4.33598V3.00004ZM3.33366 7.00264L14.0003 13.6667L24.667 7.00264V19H3.33366V7.00264Z"
        fill="#333333"/>
  </svg>
</template>

<style scoped>
svg {
  width: 32px;
  height: 32px;
  display: block;
}
</style>